import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0149d816"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-header row items-center no-wrap q-py-sm q-px-md" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-subtitle1 text-weight-bold" }, "People", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_input = _resolveComponent("search-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.searching)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_search_input, {
            ref: "searchInput",
            "model-value": _ctx.keyword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('search', $event))),
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close-search')))
          }, null, 8, ["model-value"]),
          _createVNode(_component_q_btn, {
            size: "sm",
            icon: "fa fa-times",
            color: "grey",
            flat: "",
            round: "",
            dense: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
          })
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_2,
          _createVNode(_component_q_space),
          _createVNode(_component_q_btn, {
            size: "sm",
            icon: "fa fa-search",
            color: "grey",
            flat: "",
            round: "",
            dense: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('open-search')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, { delay: 400 }, {
                default: _withCtx(() => [
                  _createTextVNode("Search")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_btn, {
            size: "sm",
            icon: "fa fa-times",
            color: "grey",
            flat: "",
            round: "",
            dense: "",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
          })
        ], 64))
  ]))
}